<div class="fp-card-media">
  @if (item?.inventoryQty) {
  <span class="fp-flag">In stock · ships today</span>
  }
  <!-- Fall back to the shared placeholder when the backend has no image (same as elsewhere). -->
  <img [src]="item?.imageUrl || 'placeholder.svg'" [class.placeholder-img]="!item?.imageUrl"
    [alt]="item?.productName" loading="lazy" />
</div>

<!-- Dimension bar: the product's width, drawn like a print ruler -->
<div class="fp-size" [class.fp-size--empty]="!facts.sizeLabel" aria-hidden="true">
  <span class="fp-size-bar"></span>
  @if (facts.sizeLabel) {
  <span class="fp-size-label">{{ facts.sizeLabel }}</span>
  <span class="fp-size-bar"></span>
  }
</div>

<div class="fp-card-body">
  <p class="fp-kicker">{{ facts.kicker }}</p>
  <p class="fp-card-title" [title]="item?.productName">
    @if (item?.urlSlug) {
    <a class="fp-card-link" [routerLink]="['/product', item.urlSlug]">{{ item?.productName }}</a>
    } @else {
    {{ item?.productName }}
    }
  </p>
  <p class="fp-spec">{{ facts.spec }}</p>
  <p class="fp-card-sub">
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8Z" stroke="currentColor"
        stroke-width="2" stroke-linejoin="round" />
      <circle cx="7" cy="7" r="1.5" fill="currentColor" />
    </svg>
    Contractor pricing available
  </p>

  <div class="fp-foot">
    @if (item?.price != null) {
    <p class="fp-price">{{ item.price | currency: 'USD' }}@if (facts.unit) {<span> / {{ facts.unit }}</span>}</p>
    } @else if (!signedIn) {
    <a class="fp-login" routerLink="/login">Log in for your pricing</a>
    } @else {
    <span></span>
    }
    <a class="fp-add" *ngIf="item?.urlSlug" [routerLink]="['/product', item.urlSlug]"
      [attr.aria-label]="'Add ' + item?.productName">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M2 3h3l2.4 12.2a1 1 0 0 0 1 .8h9.7a1 1 0 0 0 1-.8L21 7H6" stroke="currentColor" stroke-width="1.75" />
        <circle cx="9" cy="20" r="1.25" fill="currentColor" />
        <circle cx="18" cy="20" r="1.25" fill="currentColor" />
      </svg>
      Add
    </a>
  </div>
</div>
